import { useTranslation as useI18nextTranslation } from 'react-i18next';

const LANGUAGE_STORAGE_KEY = 'dualite-language';

/**
 * Custom hook for translations that provides type safety and convenience
 */
export const useTranslation = (suspense: boolean = true) => {
  const { t, i18n, ready } = useI18nextTranslation('common', {
    // suspend: true by default, set to false to disable it
    useSuspense: suspense,
  });

  const changeLanguage = async (lng: string) => {
    try {
      await i18n.changeLanguage(lng);
      // Explicitly save to localStorage to ensure persistence
      if (typeof window !== 'undefined') {
        localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
      }
    } catch (error) {
      console.error('Error changing language:', error);
    }
  };

  return {
    t,
    i18n,
    currentLanguage: i18n.language,
    changeLanguage,
    isLanguageLoaded: i18n.isInitialized,
    // use this state only when you want to control suspense behavior yourself. By default, it's handled by the hook.
    ready: suspense ? undefined : ready,
  };
};

/**
 * Utility function for quick translations outside of React components
 */
export const translate = (key: string, options?: any) => {
  // This will use the default i18n instance
  const i18n = require('i18next').default;
  return i18n.t(key, options);
};
